export default __webpack_public_path__ + "static/media/1371.f5b4eb5b.png";